import React, { useState, useEffect } from 'react';

import {
  Layout,
  Menu,
  DatePicker,
  Button,
  Space,
  Typography,
  Row,
  Col,
  List,
  Modal,
  Input,
  notification,
  Select,
  Checkbox,
  Dropdown
} from 'antd';
import Spinner from '../../CustomComponents/Spinner';
// import FacilityFilterIcon from '../../../Assets/Icons/FacilityFilterIcon';
import FacilityFilterIcon from '../../../Assets/Icons/FacilityFilterIcon';
import { FilterOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { CalendarOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { ExclamationCircleOutlined, SearchOutlined } from '@ant-design/icons';
import {
  CustomCol,
  RoasterRow,
  CloseButton,
  StyledList,
  StyledSelect,
  StyledModal,
  AuthorizationModal,
  AddpatientButton,
  StyledSearchBar,
  FacilityButton,
  FacilityFilterButton,
  StyledDatePicker,
  SearchInputRosterStyle,
  SearchFacilityDivider,
  DateRangeCol,
  AddButton,
  RosterButton,
  StyledCheckBox,
  FacilityFilterroster,
  FacilityFilterFooter,
  FacilitySelect,
  AuthorizationModalContent,
  DoctorSelect,
  CreateButton,
  StyledDivider
} from './styledComponents';

import { getUserFacilities } from '../../../Apis/User';
import {
  addPatientToRoster,
  getPatient,
  getPatientRosterOfDoctor,
  removePatientCard,
  getBillerAuthor,
  getAuthorsUnderanAdmin,
  getAccessData
} from '../../../Apis/Patient Roster';
import { Avatar } from 'antd';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';
import { DeleteConfirmationMessage } from '../Dictation/styledComponents';
import DeleteIcon from '../../../Assets/Icons/DeleteIcon';
import { SearchInputStyle } from '../styledComponents';
import { SearchDivider } from '../KeyToPhrase/styledComponents';
import { formatDate } from '../../../Utils/dateFormat';

const { Header, Content } = Layout;

const { Title, Text } = Typography;
const { Search } = Input;
const { RangePicker } = DatePicker;
const size = 'large';
const { Option } = Select;
const Roaster = () => {
  const [events, setEvents] = useState({});
  const [docModalOpen, setDocModalOpen] = useState(false);
  const [authors, setAuthors] = useState([]);
  const [docloader, setDocLoader] = useState(true);
  const [access, setAccess] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [patientName, setPatientName] = useState('');
  const [patientName1, setPatientName1] = useState('');
  const [facilities, setFacilities] = useState([]);
  const [billerAuthor, setBillerAuthor] = useState([]);
  const [authorId, setAuthorId] = useState([]);
  const [userId, setUserId] = useState([]);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [patients, setPatients] = useState([]);
  const [hoveredDate, setHoveredDate] = useState(null);
  const [facility, setFacility] = useState(null);
  const [biller, setBiller] = useState('');
  const [searchString, setSearchString] = useState('');
  const [searchStringFacility, setSearchStringFacility] = useState('');
  const [selectedPatients, setSelectedPatients] = useState([]);

  const [loader, setLoader] = useState(true);
  const [itemId, setItemId] = useState('');
  const [loader1, setLoader1] = useState(false);
  const [selectDate, setSelectDate] = useState(null);
  // const dateRange = [new Date(), new Date()]; // Example with JavaScript Date objects
  const [deleteModal, setDeleteModal] = useState(false);
  const [dateRange, setDateRange] = useState([
    moment().startOf('week'),

    moment().endOf('week')
  ]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const history = useHistory();

  const handlePccOk = () => {
    history.push('/dashboard');
    setIsModalVisible(false);
  };

  const handlePccCancel = () => {
    setIsModalVisible(false);
  };
  const userData = JSON.parse(localStorage.getItem('user'));
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const handleBatchAdd = () => {
    // const selected = patients.filter(p => selectedPatients.includes(p.id));
    // selected.forEach(patient => {
    //   handleOk(patient.name, patient.bedId, patient.id);
    // });
    const selected = patients.filter(p => selectedPatients.includes(p.id));
    const patientIds = selected.map(p => p.id);

    if (patientIds.length && selectedDate && facility) {
      addPatientToRoster1(patientIds);
    }
    setPatientName('');

    setIsModalOpen(false);

    setSelectedPatients([]); // clear selection
    handleCancel(); // close modal
  };

  useEffect(() => {
    if (userData.userType === 'biller') {
      if (authorId.length > 0) {
        handleApplyFilter();
      }
    } else {
      setLoader(true);

      if (access) {
        setAccess(false);
        getAccessData()
          .then(response => {
            if (response.data.success) {
              setAccess(true);
              // setLoader(false);
              setSearchStringFacility(new String(''));
            } else {
              setAccess(false);
              notification['error']({
                message: 'Failed',
                description: response.data.message
              });
              setLoader(false);
            }
          })
          .catch(err => console.log(err));
      }
    }
  }, [authorId]);
  useEffect(() => {
    if (userData.userType === 'biller') {
      if (authorId.length > 0) {
        handleApplyFilter();
      }
    } else {
      if (access) {
        handleApplyFilter();
      }
    }
  }, [facilities, dateRange]);

  useEffect(() => {
    if (userData.userType === 'biller') {
      getFacilities(authorId);
    }
  }, [authorId]);
  useEffect(() => {
    if (userData.userType === 'biller') {
      getBillerAuthor().then(response => {
        if (response.data.success) {
          setBillerAuthor(response.data.result);
          setLoader(false);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
          setLoader(false);
        }
      });
    } else {
      setAuthorId(userData.id);
      // getFacilities();
    }
    // getPatientRosterOfDoctor(endDate, facilityId, startDate);
  }, []);
  useEffect(() => {
    // getPatientRosterOfDoctor(endDate, facilityId, startDate);
  }, [dateRange]);
  useEffect(() => {}, [facilities]);
  useEffect(() => {
    if (facility) {
      getPatientList(facility.value, searchString);
    }
  }, [searchString]);
  useEffect(() => {
    if (authorId) {
      getFacilities(authorId, searchStringFacility);
    }
  }, [searchStringFacility]);
  const [view, setView] = useState('week');

  const daysOfWeek = Array.from({ length: 7 }, (_, i) =>
    moment(dateRange[0]).startOf('week').add(i, 'days')
  );

  const today = moment().format('YYYY-MM-DD');

  const handleDateClick = date => {
    setSelectedDate(date);

    setIsModalOpen(true); // Open the modal
  };
  const addPatientToRoster1 = patientId => {
    addPatientToRoster(
      Math.floor(
        moment(selectedDate).hour(12).minute(0).second(0).valueOf() / 1000
      ), // Set time to 12:00 PM (noon) and convert to seconds
      facility.value,
      patientId,
      authorId === userData.id ? undefined : authorId
    ) // Assuming this is your API call
      .then(response => {
        if (response.data.success) {
          // If the API call succeeds, show a success message
          notification['success']({
            message: 'Success',
            description: 'Patient has been successfully added to the roster.'
          });
          handleApplyFilter();
        } else {
          // If the API call fails but the request went through
          notification['error']({
            message: 'Failed',
            description:
              response.data.message ||
              'Failed to add patient to the roster. Please try again.'
          });
        }
        setIsModalOpen(false);
      });
  };
  const handleMultiCheck = selectedValues => {
    setSelectedFacilities(selectedValues);
  };
  const handleOk = (patientNameAdd, bedId, patientId) => {
    if (patientNameAdd && selectedDate && facility) {
      const dateStr = selectedDate.format('YYYY-MM-DD');
      addPatientToRoster1(patientId);
    }

    setPatientName('');

    setIsModalOpen(false); // Close the modal
  };
  const handleAuthor = (patientName, patientId) => {
    setAuthorId(patientId);
    setPatientName1(patientName);
    setDocModalOpen(false);
    setIsModalOpen(false); // Close the modal
  };
  const handleCancel = () => {
    setPatientName('');
    setDeleteModal(false);
    setDocModalOpen(false);
    setIsModalOpen(false); // Close the modal
  };

  // const handleDateRangeChange = dates => {
  //   setDateRange(dates);
  // };
  const handleDateRangeChange = date => {
    if (date) {
      // const newDateRange = [date.startOf('week'), date.endOf('week')];
      const newDateRange = [
        date.clone().startOf('week'),
        date.clone().endOf('week')
      ];
      setSelectDate(date);

      setDateRange(newDateRange);
    }
  };
  const handleDateSelection = date => {
    handleDateClick(date);
    if (facilities.length === 1 && userData.userType != 'biller') {
      const singleFacility = facilities[0];
      setFacility({
        value: singleFacility.value,
        label: singleFacility.label
      });
      setLoader1(true);
      getPatient(
        singleFacility.value,
        '',
        authorId === userData.id ? undefined : authorId
      )
        .then(response => {
          if (response.data.success) {
            setPatients(
              response.data.result.map(item => {
                return {
                  id: item.pid,
                  name: item.firstName + ' ' + item.lastName,
                  bedId: item.bedId,
                  date: item.lastNoteDate
                };
              })
            );
            setLoader1(false);

            // setLoader(false);
          } else {
            // if (selectedDate && selectedDate.isValid()) {
            setLoader1(false);
            setIsModalVisible(true);
            //   setPatients([]);
            // }
          }
        })
        .catch(err => console.log(err));
    }
  };
  const handleFacilityChange = value => {
    const selectedFacility = facilities.find(
      facility => facility.value === value
    );

    if (selectedFacility) {
      // Set both value and label
      setFacility({
        value: selectedFacility.value,
        label: selectedFacility.label
      });
    }
    setLoader1(true);
    getPatientList(value);
  };
  const getPatientList = (value, searchString = '') => {
    getPatient(
      value,
      searchString,
      authorId === userData.id ? undefined : authorId
    )
      .then(response => {
        if (response.data.success) {
          setPatients(
            response.data.result.map(item => {
              return {
                id: item.pid,
                name: item.firstName + ' ' + item.lastName,
                bedId: item.bedId ? item.bedId : '',
                date: item.lastNoteDate
              };
            })
          );
          setLoader1(false);
          // setLoader(false);
        } else {
          if (selectedDate && selectedDate.isValid()) {
            setIsModalVisible(true);
            setPatients([]);
          }
          // notification['error']({
          //   message: 'Failed',
          //   description: response.data.message
          // });
        }
      })
      .catch(err => console.log(err));
  };
  const handleBillerAuthorChange = value => {
    const selectedBillerAuthor = billerAuthor.find(
      billerAuthor => billerAuthor.id === value
    );

    if (selectedBillerAuthor) {
      setAuthorId(selectedBillerAuthor.id);
      // Set both value and label
      setBiller({
        id: selectedBillerAuthor.id,
        fullName: selectedBillerAuthor.fullName
      });
    }
  };

  const handleMouseLeave = () => {
    setHoveredDate(null);
  };
  const getFacilities = (authorId, searchVal) => {
    // setLoader(true);
    getUserFacilities(authorId, userData.userType, searchVal)
      .then(response => {
        if (response.data.success) {
          setSelectedFacilities(
            response.data.result.map(item => item.facilityId)
          );
          setFacilities(
            response.data.result.map(item => {
              return {
                label: item.facilityName,
                value: item.facilityId,
                disabled: item.disabled,
                className: item.disabled ? 'disabled-facility-option' : ''
              };
            })
          );
          // setLoader(false);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
          setLoader(false);
        }
      })
      .catch(err => console.log(err));
  };
  const handleSearch = event => {
    const value = event.target.value; // Extract the value from the event

    setSearchString(value);
  };
  const handleSearchFacility = event => {
    const value = event.target.value; // Extract the value from the event

    setSearchStringFacility(value);
  };

  const filteredFacilities = facilities.filter(facility =>
    facility.label.toLowerCase().includes(searchTerm)
  );
  const handleMouseEnter = date => {
    setHoveredDate(date);
  };
  const handleApplyFilter = () => {
    setLoader(true);
    getPatientRosterOfDoctor(
      Math.floor(dateRange[1].hour(12).minute(0).second(0).valueOf() / 1000),
      selectedFacilities,
      Math.floor(dateRange[0].hour(12).minute(0).second(0).valueOf() / 1000),
      authorId
    ).then(response => {
      if (response.data.success) {
        if (facilities.length > 0) {
          setLoader(false);
        }
        const result = response.data.result;
        if (Array.isArray(result)) {
          const updatedEvents = handleApiResponse(response.data.result);
          setEvents(updatedEvents);
        } else {
          notification['error']({
            message: 'Failed',
            description: 'Unexpected data format received from the server.'
          });
        }
      } else {
        // If the API call fails but the request went through
        notification['error']({
          message: 'Failed',
          description:
            response.data.message ||
            'Failed to add patient to the roster. Please try again.'
        });
        setLoader(false);
      }
    });

    setIsDropdownVisible(false);
  };

  const handleApiResponse = response => {
    // if (!response || !Array.isArray(response.result)) {
    //   console.error('Invalid response format, expected an array:', response);
    //   return {};
    // }

    const events = {};

    response.forEach(item => {
      const dateStr = moment.unix(item.dateTime).format('YYYY-MM-DD');

      const eventData = {
        patientName: item.patientName,
        facility: {
          label: item.facility.facilityName
        },
        bedId: item.bedId,
        patientId: item.patientRosterId
      };

      if (!events[dateStr]) {
        events[dateStr] = [];
      }
      events[dateStr].push(eventData);
    });

    return events;
  };
  const handleOpenModal = () => {
    setDocModalOpen(true);
    setDocLoader(true); // Show loader while fetching data

    getAuthorsUnderanAdmin()
      .then(response => {
        if (response.data.success) {
          setAuthors(response.data.result); // Store API data
        } else {
          notification.error({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(error => {
        console.error('Error fetching authors:', error);
        notification.error({
          message: 'Error',
          description: 'Something went wrong while fetching authors.'
        });
      })
      .finally(() => {
        setDocLoader(false); // Hide loader after API call completes
      });
  };
  const handleSwitch = () => {
    setAuthorId(userData.id);
  };
  const handleCancelFilter = () => {
    // setSelectedFacilities([]);
    setIsDropdownVisible(false);
  };

  const handleClearCheckboxes = () => {
    setSelectedFacilities([]);
  };
  const handleDelete = () => {
    removePatientCard(itemId).then(response => {
      if (response.data.success) {
        setDeleteModal(false);
        handleApplyFilter();
      }
    });
    setDeleteModal(false);
  };
  const handleDeleteModal = itemId => {
    setDeleteModal(true);
    setItemId(itemId);
  };
  const facilityMenu = (
    <div
      style={{
        borderRadius: '8px',
        padding: '10px',
        // boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        border: '1px solid #d9d9d9',
        backgroundColor: 'white'
      }}
    >
      <FacilityFilterroster>
        <span
          style={{
            fontWeight: 'bold',
            paddingLeft: '5px'
          }}
        >
          Filter Facilities
        </span>
        <Button
          type='link'
          style={{ padding: '0', fontSize: '14px', color: '#1890ff' }}
          onClick={handleClearCheckboxes}
        >
          Clear
        </Button>
      </FacilityFilterroster>
      <SearchFacilityDivider></SearchFacilityDivider>
      <SearchInputRosterStyle
        key='search'
        placeholder='Search Facility'
        prefix={<SearchOutlined />}
        onChange={handleSearchFacility}
        style={{
          marginBottom: '10px'
        }}
      />
      <SearchFacilityDivider></SearchFacilityDivider>
      <Checkbox.Group
        value={selectedFacilities} // This binds the checked state
        onChange={handleMultiCheck}
        key='checkboxes'
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '5px',
          maxHeight: '400px', // Adjust this value as needed
          overflowY: 'auto'
        }}
      >
        {filteredFacilities
          .filter(facility => !facility.isParent) // Filter out parent items
          .map(facility => (
            <StyledCheckBox
              prefixCls='rosterFacilitycheckBox'
              key={facility.value}
              value={facility.value}
              checked={selectedFacilities.includes(facility.value)}
            >
              {facility.label}
            </StyledCheckBox>
          ))}
      </Checkbox.Group>
      <FacilityFilterFooter>
        <Button
          type='primary'
          style={{
            borderRadius: '20px',
            padding: '4px 20px',
            backgroundColor: '#1890ff',
            borderColor: '#1890ff'
          }}
          onClick={handleApplyFilter}
        >
          Apply
        </Button>
        <FacilityFilterButton
          style={{
            borderRadius: '20px',
            padding: '4px 20px',
            backgroundColor: '#f0f0f0',
            borderColor: '#d9d9d9'
          }}
          onClick={handleCancelFilter}
        >
          Cancel
        </FacilityFilterButton>
      </FacilityFilterFooter>
    </div>
  );

  return (
    <>
      <Content style={{ padding: '10px' }}>
        {access && (
          <RoasterRow
            gutter={[16, 16]}
            justify='space-between'
            align='middle'
            style={{
              width: '100%',
              backgroundColor: 'white',
              marginLeft: '0px'
            }}
          >
            {userData.userType === 'biller' ? (
              <Col span={4}>
                <DoctorSelect
                  placeholder='Select Author'
                  value={biller.fullName}
                  onChange={handleBillerAuthorChange}
                >
                  {billerAuthor.map(billerAuthor => (
                    <Option key={billerAuthor.id} value={billerAuthor.id}>
                      {billerAuthor.fullName}
                    </Option>
                  ))}
                </DoctorSelect>
              </Col>
            ) : (
              <Col span={14}>
                <span className='rosterhead'>
                  {authorId === userData.id
                    ? 'My Patient Roster'
                    : `Patient Roster of ${patientName1}`}
                </span>
              </Col>
            )}

            <DateRangeCol span={3}>
              <StyledDatePicker
                value={selectDate}
                onChange={handleDateRangeChange}
                picker='week'
                format={value => value.format('DD MMM YYYY')}
                size='default'
                style={{ backgroundColor: '#F4F4F5', borderRadius: '4px' }}
              />
            </DateRangeCol>
            {(userData.userType === 'admin' ||
              userData.userType === 'clinicAdmin') && (
              <Col span={4}>
                {authorId === userData.id ? (
                  <RosterButton type='primary' onClick={handleOpenModal}>
                    Create Roster for other Docter
                  </RosterButton>
                ) : (
                  <RosterButton type='primary' onClick={handleSwitch}>
                    Create Roster for Own
                  </RosterButton>
                )}
              </Col>
            )}
            <Col span={3}>
              <Dropdown
                overlay={facilityMenu}
                trigger={['click']}
                visible={isDropdownVisible}
                onVisibleChange={visible => setIsDropdownVisible(visible)}
              >
                <div className='test'>
                  <FacilityButton
                    type='default'
                    icon={<FacilityFilterIcon />}
                    style={{
                      display: 'flex',

                      alignItems: 'center'
                    }}
                  >
                    <span style={{ marginLeft: '8px' }}>Facility</span>
                  </FacilityButton>
                </div>
              </Dropdown>
            </Col>
          </RoasterRow>
        )}
        {loader ? (
          <Spinner height={'20vh'} />
        ) : (
          access && (
            <Row
              style={{
                height: 'calc(100vh - 200px)',
                width: '100%',
                display: 'flex'
              }}
            >
              {daysOfWeek.map(day => (
                <CustomCol
                  key={day.format('YYYY-MM-DD')}
                  onMouseEnter={() =>
                    handleMouseEnter(day.format('YYYY-MM-DD'))
                  }
                  onMouseLeave={handleMouseLeave}
                  // onClick={() => handleDateSelection(day)}
                  className={day.format('YYYY-MM-DD') === today ? 'today' : ''}
                >
                  <div className='patient-sheduler'>
                    <Text className='day-text'>{day.format('ddd')}</Text>

                    <br />

                    <Text className='date-text'>{day.format('DD')}</Text>
                    {day.format('YYYY-MM-DD') === today && (
                      <Text className='today-text'>TODAY</Text>
                    )}
                  </div>

                  <div style={{ flexGrow: 1 }}>
                    <List
                      dataSource={events[day.format('YYYY-MM-DD')] || []}
                      renderItem={item => (
                        <List.Item className='patientdetails'>
                          <span className='patientNameCard'>
                            {item.patientName}
                            <CloseButton
                              onClick={e => handleDeleteModal(item.patientId)}
                              icon={<CloseOutlined className='closeIcon' />}
                            />
                          </span>
                          <div className='facilityNameCard'>
                            <span className='bedcard'>
                              {' '}
                              Bed
                              {item.bedId}{' '}
                            </span>{' '}
                            <span className='bedcard'>
                              {item.facility.label}
                            </span>
                          </div>
                        </List.Item>
                      )}
                    />

                    {userData.userType !== 'biller' &&
                      (day.format('YYYY-MM-DD') === hoveredDate ||
                        day.format('YYYY-MM-DD') === today) && (
                        <AddpatientButton
                          type='primary'
                          icon={<PlusOutlined className='bold-icon' />}
                          onClick={() => handleDateSelection(day)}
                        >
                          Add Patient
                        </AddpatientButton>
                      )}
                  </div>

                  <div style={{ textAlign: 'center', marginTop: '10px' }}></div>
                </CustomCol>
              ))}
            </Row>
          )
        )}
        <AuthorizationModal
          visible={isModalVisible}
          onCancel={handlePccCancel}
          footer={null}
          centered
          className='authorization-modal'
        >
          <div className='modal-content'>
            <div className='icon'>
              <div className='icon-wrapper'>
                <ExclamationCircleOutlined className='warning-icon' />
              </div>
            </div>
            <AuthorizationModalContent>
              <h3 style={{ textAlign: 'center' }}>
                You are not authorized to edit this. Please complete the
                authorization
              </h3>
              <p>
                You are not authorized to edit the roster of this facility.
                Please complete the authorization and to edit this roster.
              </p>
              <Button
                type='primary'
                className='authorization-button'
                onClick={handlePccOk}
              >
                Complete Authorisation
              </Button>
            </AuthorizationModalContent>
          </div>
        </AuthorizationModal>
        <ConfirmationModal
          visible={deleteModal}
          onOk={handleDelete}
          onCancel={handleCancel}
          centered
          // loading={deleteLoading}
          confirmation={true}
          antdModalProps={{ closable: false, mask: false }}
        >
          <DeleteIcon />
          <DeleteConfirmationMessage>
            Are you sure you want to delete?
          </DeleteConfirmationMessage>
        </ConfirmationModal>

        <StyledModal
          centered
          title='Add Patient'
          open={isModalOpen}
          // onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
        >
          <FacilitySelect
            placeholder='Select facility'
            value={facility}
            onChange={handleFacilityChange}
          >
            {facilities.map(facility => (
              <Option key={facility.value} value={facility.value}>
                {facility.label}
              </Option>
            ))}
          </FacilitySelect>

          <StyledDivider />

          <SearchInputRosterStyle
            placeholder='Search Patient'
            prefix={<SearchOutlined />}
            onChange={handleSearch}
          />

          <StyledDivider />

          {loader1 ? (
            <Spinner height={'2vh'} />
          ) : (
            patients.length > 0 && (
              <>
                <StyledList
                  dataSource={patients}
                  renderItem={patient => (
                    <List.Item>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%'
                        }}
                      >
                        <Checkbox
                          value={patient.id}
                          checked={selectedPatients.includes(patient.id)}
                          onChange={e => {
                            const checked = e.target.checked;
                            if (checked) {
                              setSelectedPatients(prev => [
                                ...prev,
                                patient.id
                              ]);
                            } else {
                              setSelectedPatients(prev =>
                                prev.filter(id => id !== patient.id)
                              );
                            }
                          }}
                          style={{ marginRight: 12 }}
                        />
                        <List.Item.Meta
                          avatar={<Avatar size={48}>{patient.name[0]}</Avatar>}
                          title={patient.name}
                          description={`Bed ID: ${patient.bedId} | Date: ${
                            patient.date ? formatDate(patient.date) : ''
                          }`}
                        />
                      </div>
                    </List.Item>
                  )}
                  style={{
                    maxHeight: '350px',
                    overflowY: 'auto'
                  }}
                />
                <div className='modal-footer-fixed'>
                  <CreateButton
                    type='primary'
                    icon={<PlusOutlined />}
                    onClick={handleBatchAdd}
                    disabled={selectedPatients.length === 0}
                    block
                  >
                    Add Selected Patients
                  </CreateButton>
                </div>
              </>
            )
          )}
        </StyledModal>

        <StyledModal
          centered
          title='Docters List'
          open={docModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
        >
          <StyledDivider />

          {loader ? (
            <Spinner height={'20vh'} />
          ) : (
            authors.length > 0 && (
              <StyledList
                dataSource={authors}
                renderItem={patient => (
                  <List.Item
                    actions={[
                      <AddButton
                        type='primary'
                        icon={<PlusOutlined className='bold-icon' />}
                        onClick={() =>
                          handleAuthor(patient.doctorName, patient.doctorId)
                        }
                      >
                        Create
                      </AddButton>
                    ]}
                  >
                    <List.Item.Meta
                      avatar={
                        <Avatar size={64}>{patient.doctorName[0]}</Avatar>
                      }
                      title={patient.doctorName}
                    />
                  </List.Item>
                )}
                style={{
                  maxHeight: '400px',

                  overflowY: 'auto'
                }}
              />
            )
          )}
        </StyledModal>
      </Content>
    </>
  );
};

export default Roaster;
